import UserAvatar from "@/components/AvatarComponent/UserAvatar";
import classNames from "classnames";
import { PlacementAll } from "../../common/Placements";
import BFOverlay from "../whisper/BFOverlay";
import "./BFIndicatorOverlay.scss";

export type BFIndicatorOverlayLevel = "partially" | "full" | "warn";
export interface Props {
  level?: BFIndicatorOverlayLevel;
  placement?: PlacementAll;
  validatedBy?: string;
  /**
   * The content to render inside the overlay. This can be a React node
   * or a function that returns a React node.
   */
  speakerFC?: (close: () => void) => JSX.Element;
  identifier?: string;
}

const BFIndicatorOverlay = (props: Props) => {
  const { speakerFC, placement, level, validatedBy, identifier } = props;
  // Render the speaker content either directly or via the render function.

  return (
    <BFOverlay
      placement={placement}
      enterable
      ignoreFocusOnExit
      speakerFC={speakerFC}
      identifier={identifier}
    >
      <div className="bf-indicator-overlay__trigger">
        {validatedBy ? (
          <div className="bf-indicator-overlay__validated-by">
            {/* Replace the img below with your actual avatar component if needed */}
            <UserAvatar id={validatedBy} size={24} />
            <div className={classNames("bf-indicator", level)} />
          </div>
        ) : (
          <div className={classNames("bf-indicator", level)} />
        )}
      </div>
    </BFOverlay>
  );
};

export default BFIndicatorOverlay;
